import { BoxTool } from './BoxTool'

const isClientContext = typeof window === 'object';

export class MosaicTool extends BoxTool {
	constructor() {
		super({
			mode: 'mosaic',
			name: '马赛克工具',
			className: 'mosaic',
			supported: isClientContext && !/msie|trident/.test(navigator.userAgent.toLocaleLowerCase())
		});
	}

	onRenderCanvas(ctx, drawing) {
		const { param, sourceImage, brushColor, brushWidth, cache } = drawing;
		const [x, y, width, height] = param;

		if (!width || !height) return;

		ctx.save();
		if (!cache.mosaicData) {
			const sourceData = this.getImageSourceData(sourceImage, x, y, width, height);
			cache.mosaicData = this.doMosaic(sourceData, (brushWidth + 1) * (brushWidth + 1));
		}
		ctx.putImageData(cache.mosaicData, x, y);
		ctx.restore();
	}

	/**
	 * 获取图片在指定矩形区域的图像数据
	 * @param {HTMLImageElement} image
	 * @param {number} x
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 */
	getImageSourceData(image, x, y, width, height) {
		const canvas = document.createElement('canvas');
		canvas.width = width;
		canvas.height = height;
		const ctx = canvas.getContext('2d');
		ctx.drawImage(image, -x, -y);
		return ctx.getImageData(0, 0, width, height);
	}

	/**
	 * 返回马赛克后的图像
	 * @param {ImageData} imageData
	 * @param {number} size
	 */
	doMosaic(imageData, size) {
		const { width, height, data } = imageData;
		const mosaicData = new Uint8ClampedArray(width * height * 4);

		const pixelPosition = (i, j) => (4 * (i + width * j));
		const pixelData = (data, i, j) => data.slice(pixelPosition(i, j), pixelPosition(i, j) + 4);
		const fillPixel = (destData, di, dj, srcData, si, sj) => {
			let d = pixelPosition(di, dj);
			let s = pixelPosition(si, sj);
			destData[d++] = srcData[s++];
			destData[d++] = srcData[s++];
			destData[d++] = srcData[s++];
			destData[d++] = srcData[s++];
		}
		const takeMosaicSample = (i, j, size) => {
			let sr = 0, sg = 0, sb = 0, sa = 0, count = 0;
			for (let k = 0; k < size && i + k < width; k++) {
				for (let l = 0; l < size && j + l < height; l++) {
					const [r, g, b, a] = pixelData(data, i + k, j + l);
					sr += r;
					sg += g;
					sb += b;
					sa += a;
					count++;
				}
			}
			return [Math.round(sr / count), Math.round(sg / count), Math.round(sb / count), Math.round(sa / count)];
		};

		for (let i = 0; i < width; i++) {
			for (let j = 0; j < height; j++) {
				const xof = i % size;
				const yof = j % size;
				if (!xof && !yof) {
					const mosaicSample = takeMosaicSample(i, j, size);
					fillPixel(mosaicData, i, j, mosaicSample, 0, 0);
				}
			}
		}

		for (let i = 0; i < width; i++) {
			for (let j = 0; j < height; j++) {
				const xof = i % size;
				const yof = j % size;
				if (xof || yof) {
					fillPixel(mosaicData, i, j, mosaicData, i - xof, j - yof);
				}
			}
		}

		return new ImageData(mosaicData, width, height);
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/MosaicTool.js